import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type ArchiveGivingActionSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function ArchiveGivingActionSuccessModal({ isOpen, handleClose }: ArchiveGivingActionSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="archive-giving-action-success">
      <AcknowledgeModal
        result="positive"
        title={t('dialog.givingActions.archive.successTitle')}
        description={t('dialog.givingActions.archive.successDescription')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="archive-giving-action-success-modal-btn"
      />
    </Modal>
  )
}
